import { useMemo } from "react";
import { useQueries } from "@tanstack/react-query";
import { q_vaultbikesinf } from "@/queries/queries.jsx";
import { getv } from "../utils/utils.jsx";
import _ from "lodash";

export function useVaultCoresInf(vault, enabled = true) {
  const [qo_vault_cores_inf] = useQueries({
    queries: [q_vaultbikesinf({ vault }, { enabled })],
  });

  const hmap = useMemo(() => {
    let d = getv(qo_vault_cores_inf, "data.result", []);
    d = _.keyBy(d, "hid");
    return d;
  }, [qo_vault_cores_inf.dataUpdatedAt]);

  return {
    query: qo_vault_cores_inf,
    hmap,
    loading: qo_vault_cores_inf.status === "loading",
    error: qo_vault_cores_inf.error,
    success: qo_vault_cores_inf.status === "success",
  };
}

